<template>
  <div class="findPass w100 pr">
    <div class="find_wrap">
      <div class="center mb35"><img src="@/assets/pass_logo.png"></div>
      <div class="find_body white">
        <div class="find_head fs18 center mb35">找回密码</div>
        <el-steps :active="activeStep" align-center>
          <el-step title="身份验证" />
          <el-step title="重置密码" />
          <el-step title="完成" />
        </el-steps>
        <div v-if="activeStep == 0">
          <el-form ref="regRuleForm" :model="regForm" :rules="regRules" status-icon label-width="80px" style="width: 500px;margin: 60px auto;">
            <el-form-item label="手机号码" prop="mobile" class="mb35">
              <el-input v-model="regForm.mobile" type="text" maxlength="11" placeholder="请输入手机号" @input="regForm.mobile = regForm.mobile.replace(/\D/g, '')" />
            </el-form-item>
            <el-form-item label="验证码" prop="regcode" class="mb35">
              <div class="flex">
                <el-input v-model="regForm.regcode" type="text" placeholder="请输入验证码" maxlength="4" @input="regForm.regcode = regForm.regcode.replace(/\D/g, '')" />
                <el-button v-if="!isSend" class="active_color ml20" @click="getCode">{{ str }}</el-button>
                <el-button v-if="isSend" class="ml20" disabled>{{ countStr }}</el-button>
              </div>
            </el-form-item>
          </el-form>
          <div class="center">
            <el-button type="primary" class="next_btn fs16" @click="submitForm('regRuleForm')">下一步</el-button>
          </div>
        </div>
        <div v-if="activeStep == 1">
          <el-form ref="passRuleForm" :model="passForm" :rules="passRules" status-icon label-width="95px" style="width: 500px;margin: 60px auto;">
            <el-form-item label="新密码" prop="newpass" class="mb35">
              <el-input v-model="passForm.newpass" type="password" placeholder="请输入新密码" />
            </el-form-item>
            <el-form-item label="确认新密码" prop="surepass" class="mb35">
              <el-input v-model="passForm.surepass" type="password" placeholder="请再次输入新密码" :disabled="!passForm.newpass" />
            </el-form-item>
          </el-form>
          <div class="center">
            <el-button type="primary" class="next_btn fs16" @click="submit('passRuleForm')">提交</el-button>
          </div>
        </div>
        <div v-if="activeStep == 2">
          <div class="fs24 active_color center" style="margin: 100px auto;"><i class="el-icon-success mr10" />您的密码已重置成功！</div>
          <div class="center">
            <el-button type="primary" class="next_btn fs16" @click="$router.replace('/login')">去登录</el-button>
          </div>
        </div>
      </div>
    </div>
    <img src="@/assets/wave.png" class="wave w100 pf">
  </div>
</template>

<script>
import { sendsmsCode } from '@/api/common'
import { mapActions } from 'vuex'
import { getLocationUri } from '@/utils/fn'

export default {
  data() {
    const validateMobile = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else {
        if (!/^1[3456789]\d{9}$/.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      }
    }
    const validateRegcode = (rule, value, callback) => {
      if (!this.regForm.mobile) {
        callback(new Error('请先输入手机号'))
      } else if (!this.code) {
        callback(new Error('请先获取短信验证码'))
      } else if (!value) {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    const validateNewpass = (rule, value, callback) => {
      var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,}$/
      if (value === '' || value === undefined) {
        callback(new Error('请输入新密码'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入8位及以上字母和数字组合的密码'))
      } else {
        if (this.passForm.surepass !== '' || this.passForm.surepass !== undefined) {
          this.$refs.passRuleForm.validateField('surepass')
        }
        callback()
      }
    }
    const validateSurepass = (rule, value, callback) => {
      if (this.passForm.newpass === '' || this.passForm.newpass === undefined) {
        callback(new Error('请先输入新密码'))
      }
      if (value === '' || value === undefined) {
        callback(new Error('请再次输入新密码'))
      } else if (value !== this.passForm.newpass) {
        callback(new Error('两次输入密码不一致'))
      } else {
        callback()
      }
    }
    return {
      activeStep: 0,
      regForm: {},
      regRules: {
        mobile: [{ required: true, validator: validateMobile, trigger: 'change' }],
        regcode: [{ required: true, validator: validateRegcode, trigger: 'change' }]
      },
      code: '',
      str: '获取验证码',
      countStr: '重新发送（60s）',
      isSend: false,
      timer: null,
      passForm: {
        newpass: '',
        surepass: '',
        request_uri: ''
      },
      passRules: {
        newpass: [{ required: true, validator: validateNewpass, trigger: 'change' }],
        surepass: [{ required: true, validator: validateSurepass, trigger: 'change' }]
      }
    }
  },
  created() {},
  methods: {
    ...mapActions('user', ['smsupdatePassFn', 'versmscodeFn']),
    getCode() {
      this.$refs.regRuleForm.validateField('mobile', (errorMessage) => {
        if (!errorMessage) {
          sendsmsCode({ account: this.regForm.mobile }).then(data => {
            if (data) {
              this.code = 1
              this.isSend = true
              this.timer = null
              let time = 60
              this.timer = setInterval(() => {
                if (time === 0) {
                  this.str = '重新获取验证码'
                  this.countStr = '重新发送（60s）'
                  this.isSend = false
                  clearInterval(this.timer)
                } else {
                  time--
                  this.countStr = `重新发送（${time}s）`
                }
              }, 1000)
            }
          })
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.versmscodeFn({ account: this.regForm.mobile, code: this.regForm.regcode }).then(res => {
            if (res.code === 200) {
              clearInterval(this.timer)
              this.activeStep++
              this.$nextTick(() => {
                this.$refs.passRuleForm.clearValidate(['newpass', 'surepass'])
              })
            }
          })
        } else {
          return false
        }
      })
    },
    submit(formName) {
      this.passForm.request_uri = getLocationUri()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.smsupdatePassFn({
            account: this.regForm.mobile,
            code: this.regForm.regcode,
            new_pass: this.passForm.newpass,
            request_uri: this.passForm.request_uri
          }).then(data => {
            if (data) {
              this.activeStep++
            }
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.findPass{
  background-color: #F5F9FF;
  height: 100%;
  .find_wrap{
    border-top: 6px solid #2d8cf0;
    background-color: #F5F9FF;
    background-image: url('../../assets/login_bg.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 6%;
    padding-bottom: 60px;
    .find_body{
      width: 830px;
      height: 530px;
      border-radius: 10px;
      box-shadow: 0 1px 14px 2px rgba(45, 140, 240, 0.09);
      margin: 0 auto;
      .find_head{
        height: 80px;
        line-height: 80px;
        border-bottom: 1px solid #E3EDFF;
      }
      .el-step__title{
        font-size: 12px;
      }
      .el-step__line{
        background-color: #e8e8e8;
      }
      .el-step__icon.is-text{
        border-color: #e8e8e8;
      }
      .el-step__head.is-process,.el-step__head.is-finish{
        .el-step__icon.is-text{
          border-color: #2d8cf0;
        }
      }
      .el-step__head.is-finish .el-step__line{
        background: #2d8cf0;
      }
      .el-step__head.is-process{
        color: #2d8cf0;
        border-color: #2d8cf0;
      }
      .el-step__title.is-process{
        color: #2d8cf0;
      }
      .el-input__inner{
        border-radius: 0;
        border: none;
        border-bottom: 1px solid #DCDFE6;
      }
      .el-input.is-disabled .el-input__inner{
        background: none;
      }
      .el-form-item--feedback .el-input__validateIcon.el-icon-circle-check{
        color: #2d8cf0;
      }
      .next_btn{
        width: 310px;
        height: 46px;
      }
    }
  }
  .wave{
    bottom: 0;
  }
}
</style>
